module.exports = __webpack_public_path__ + "static/media/01.908ee4f9.jpg";